import { render, staticRenderFns } from "./AS_RechargePrepaid.vue?vue&type=template&id=66ec054a&scoped=true&"
import script from "./AS_RechargePrepaid.vue?vue&type=script&lang=js&"
export * from "./AS_RechargePrepaid.vue?vue&type=script&lang=js&"
import style0 from "./AS_RechargePrepaid.vue?vue&type=style&index=0&id=66ec054a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ec054a",
  null
  
)

export default component.exports